import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-assets', 'labelMore', 'Rādīt vairāk');
Labels.set('ui-assets', 'labelLess', 'Rādīt mazāk');
Labels.set(
    'ui-assets',
    'labelToggleContent',
    'Pašlaik redzami {visibleAssets} no {allAssets} saraksta vienumiem.'
);
